<template>
  <div class="pay-count">
    <div class="ly-card hd">
      <el-select v-model="searchFormData.year" placeholder="学年">
        <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-select v-model="searchFormData.term" placeholder="学期">
        <el-option :key="-1" label="全部" :value="-1"> </el-option>
        <el-option v-for="item in terms" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <el-select
        style="width: 200px"
        v-model="searchFormData.org_id"
        placeholder="部门"
        @change="getRootSp"
        @clear="search"
        filterable
        clearable
      >
        <el-option v-for="item in org_ids" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
      <el-select
        v-model="searchFormData.root_specialized_subject_id"
        placeholder="项目大类"
        :disabled="!searchFormData.org_id"
        @clear="search"
        @change="getSp"
        filterable
        clearable
      >
        <el-option v-for="item in root_specialized_subject_ids" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-select
        @clear="search"
        @change="search"
        v-model="searchFormData.specialized_subject_id"
        placeholder="项目"
        filterable
        clearable
        :disabled="!searchFormData.org_id || !searchFormData.root_specialized_subject_id"
      >
        <el-option v-for="item in specialized_subject_ids" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <br />
      <el-date-picker
        v-model="date"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        value-format="yyyy-MM-dd"
        clearable
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <el-input style="width: 200px" v-model="searchFormData.query" placeholder="班级名字检索"></el-input>
      <div class="fr m-t-5">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="exportExcel">导出</el-button>
      </div>
    </div>
    <div class="ly-card" v-loading="loading">
      <table class="native-table">
        <tr>
          <th
            v-for="item in tableHeader"
            :key="item.value"
            v-show="isShowClassCode(item)"
          >
            {{ item.name }}
          </th>
        </tr>
        <tr v-show="tableConfig.data.length" v-for="(item, index) in tableConfig.data" :key="index">
          <!-- <td></td> -->
          <td
            v-for="curItem in tableHeader"
            :key="`${curItem.value}-${index}`"
            v-show="isShowClassCode(curItem)"
          >
            <div v-if="curItem.value === 'name'&&hasClassCode===false">
              <span v-if="searchFormData.org_id">{{ item[curItem.value] }}</span>
              <el-button v-else type="text" size="small" @click="changeOrg(item)">{{ item[curItem.value] }}</el-button>
            </div>
            <div  v-if="curItem.value !== 'name'" >
              {{ item[curItem.value] }}
            </div>
            <div v-if="curItem.value === 'name'&&hasClassCode===true">
              <el-button type="text" size="small" @click="classInf(item)">{{ item[curItem.value] }}</el-button>
            </div>
          </td>
        </tr>
        <tr v-show="tableConfig.data && tableConfig.data.length" class="total-count">
          <td>总计</td>
          <td v-if="hasClassCode"></td>
          <td>{{ count_list.class_fee }}</td>
          <td>{{ count_list.insurance }}</td>
          <td>{{ count_list.material_fee }}</td>
          <td>{{ count_list.hosting_fee }}</td>
          <td>{{ count_list.food_expenses }}</td>
          <td>{{ count_list.accompanying_fee }}</td>
          <td>{{ count_list.total_fee }}</td>
          <td>{{ count_list.paid_count }}</td>
          <td>{{ count_list.refund_count }}</td>
          <td>{{ count_list.real_course_count }}</td>
        </tr>
        <tr v-if="!tableConfig.data.length">
          <td :colspan="tableHeader.length">暂无数据</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import { Select, Option, DatePicker, Input } from 'element-ui';
import { payCountTable } from '@/utils/tableHeader';
import { finance } from '@/api';
import utils from '@/utils/utils';

export default {
  name: 'PayCount',
  components: { ElSelect: Select, ElOption: Option, ElDatePicker: DatePicker, ElInput: Input },
  data() {
    return {
      searchFormData: {
        org_id: '',
        year: new Date().getFullYear(),
        term: '',
        query: '',
        specialized_subject_id: '',
        root_specialized_subject_id: '',
        date: []
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      date: [
        dayjs()
          .subtract(1, 'month')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      tableHeader: payCountTable,
      tableConfig: {
        data: []
      },
      count_list: {},
      paginConfig: {
        isHide: true
      },
      terms: [],
      years: [],
      loading: false,
      org_ids: [],
      root_specialized_subject_ids: [],
      specialized_subject_ids: [],
      hasClassCode: false
    };
  },
  mounted() {
    this.$store.dispatch('schoolYear/getTermAndYearList').then(data => {
      if (data) {
        this.years = data.year;
        this.terms = data.term;
        this.searchFormData.term = data.term[0].value;
        this.search();
      }
    });
    this.getOrg();
  },
  methods: {
    isShowClassCode(item) {
      return item.value !== 'class_code' || this.searchFormData.specialized_subject_id;
    },
    change(key, value) {
      this.searchFormData[key] = value;
    },
    getOrg() {
      finance.orgQuery().then(res => {
        if (res) {
          this.org_ids = res.data.list;
        }
      });
    },
    changeOrg(row) {
      this.searchFormData.org_id = row.org_id;
      this.getRootSp();
    },
    getRootSp() {
      this.searchFormData.specialized_subject_id = '';
      this.searchFormData.root_specialized_subject_id = '';
      if (this.searchFormData.org_id) {
        finance.rootSpecializedSubjectQuery({ org_id: this.searchFormData.org_id }).then(res => {
          if (res) {
            this.root_specialized_subject_ids = res.data.list;
          }
        });
      } else {
        this.root_specialized_subject_ids = [];
      }
      this.search();
    },
    getSp() {
      this.searchFormData.specialized_subject_id = '';
      if (this.searchFormData.org_id && this.searchFormData.root_specialized_subject_id) {
        finance
          .specializedSubjectQuery({
            org_id: this.searchFormData.org_id,
            root_specialized_subject_id: this.searchFormData.root_specialized_subject_id
          })
          .then(res => {
            if (res) {
              this.specialized_subject_ids = res.data.list;
            }
          });
      } else {
        this.specialized_subject_ids = [];
      }
      this.search();
    },
    search() {
      const temp = {
        ...this.searchFormData,
        pay_time_start: this.date && this.date.length ? `${this.date[0]} 00:00:00` : -1,
        pay_time_end: this.date && this.date.length ? `${this.date[1]} 23:59:59` : -1
      };
      this.loading = true;
      Object.keys(temp).forEach(key => {
        const value = temp[key];
        if (value && value !== -1) temp[key] = value;
        else delete temp[key];
      });
      finance.signUpPurchaseStatistics(temp).then(res => {
        if (res) {
          this.count_list = res.data.total;
          this.tableConfig = {
            data: res.data.list
          };
          if (this.tableConfig.data[0] && this.tableConfig.data[0].class_code) {
            this.hasClassCode = true;
          } else {
            this.hasClassCode = false;
          }
        }
        this.loading = false;
      });
    },
    classInf(row) {
      let root_name = '';
      let special_name = '';
      this.root_specialized_subject_ids.forEach(item => {
        if (this.searchFormData.root_specialized_subject_id === item.id) {
          root_name = item.name;
        }
      });
      this.specialized_subject_ids.forEach(item => {
        if (this.searchFormData.specialized_subject_id === item.id) {
          special_name = item.name;
        }
      });
      const routeUrl = this.$router.resolve(
        `/${this.$route.params.user_id}/classes/enrolment/${row.class_id}?class_phase=1&name=${row.name}&fee_level=${root_name}/${special_name}`
      );
      window.open(routeUrl.href, '_blank');
    },
    exportExcel() {
      const params = { ...this.searchFormData };
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === -1) delete params[key];
      });
      finance
        .exportSignUpPurchase({
          params
        })
        .then(data => {
          if (data) utils.downloadData(data, '报名收费统计');
        });
    }
  }
};
</script>
<style lang="less">
.pay-count {
  .hd {
    .el-select {
      width: 165px;
    }
    .ly-search-comp {
      display: inline-block;
      width: 200px;
      .el-select {
        width: 100%;
      }
      .el-input {
        width: 100%;
      }
    }
    > * {
      margin: 10px;
    }
  }
  .total-list {
    > span {
      padding: 5px 10px;
      display: inline-block;
    }
  }
  .total-count {
    font-weight: 700;
  }
}
</style>
